<template>
  <div>
    <div
      v-if="relatedColorProducts && relatedColorProducts.length && !props.onlyLink"
      class="variations"
    >
      <div class="variations__heading heading heading--6">
        <!-- <span>{{ $t('Related color count', { count: relatedColorProducts.length }, relatedColorProducts.length) }}</span> -->
        <span>{{ $t('Choose your color') }}</span>
      </div>

      <div class="variations__content">
        <ul class="variations__list">
          <li class="variations__item">
            <span class="variations__link current">
              <span class="variations__visual">
                <img
                  :src="productImageUrl(
                    product?.image,
                    product?.name,
                    product?.imageSize || 'M standaard',
                    92,
                    124)"
                  width="46"
                  height="62"
                  :alt="product?.name"
                  loading="lazy"
                  class="variations__image"
                >
              </span>
            </span>
          </li>
          <li
            v-for="item in relatedColorProducts.slice(0, limit)"
            :key="item.id"
            class="variations__item"
          >
            <AppLink
              :to="link(item)"
              class="variations__link"
            >
              <span class="variations__visual">
                <img
                  :src="productImageUrl(
                    item.image,
                    item.name,
                    item.imageSize || 'M standaard',
                    92,
                    124,
                  )"
                  width="46"
                  height="62"
                  :alt="item.name"
                  loading="lazy"
                  class="variations__image"
                >
              </span>
            </AppLink>
          </li>
        </ul>

        <button
          v-if="relatedColorProducts.length > limit"
          type="button"
          class="variations__more"
          @click="modalColors.open"
        >
          +{{ relatedColorProducts.length - limit + 1 }}
        </button>
      </div>
    </div>

    <div v-else-if="relatedColorProducts && relatedColorProducts.length && props.onlyLink">
      <AppLink
        class="variations__link"
        @click.prevent="modalColors.open"
      >
        <span>+{{ relatedColorProducts.length }} {{ $t('Colors') }}</span>
      </AppLink>
    </div>

    <LazyUiDialog
      class="variants__modal"
      name="modal-colors"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        {{ $t('Colors') }}
      </template>

      <ul class="modal-colors__content">
        <li class="variations__item">
          <span class="variations__link current">
            <span class="variations__visual">
              <img
                :src="productImageUrl(
                  product?.image,
                  product?.name,
                  product?.imageSize || 'M standaard',
                  144,
                  192,
                )"
                width="72"
                height="96"
                :alt="product?.name"
                loading="lazy"
                class="variations__image"
              >
            </span>

            <span class="variations__label">{{ product.supplierColor || product?.color.label }}</span>
          </span>
          <!-- <pre>{{ product }}</pre> -->
        </li>
        <li
          v-for="item in relatedColorProducts"
          :key="item.id"
          class="variations__item"
        >
          <AppLink
            :to="link(item)"
            class="variations__link"
            @click="modalColors.close"
          >
            <span class="variations__visual">
              <img
                :src="productImageUrl(
                  item.image,
                  item.name,
                  item.imageSize || 'M standaard',
                  144,
                  192,
                )"
                width="72"
                height="96"
                :alt="item.name"
                loading="lazy"
                class="variations__image"
              >
            </span>

            <span class="variations__label">
              {{ item.supplierColor || item.color.label }}
            </span>
            <!-- <pre>{{ item }}</pre> -->
          </AppLink>
        </li>
      </ul>
    </LazyUiDialog>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  product?: any
  onlyLink?: boolean
}>()

const { breakpoint } = useApp()

const limits = {
  mobile: 4,
  phablet: 5,
  tablet: 3,
  desktop: 4,
  widescreen: 5,
} as const

const limit = computed(() =>
  limits[breakpoint.value as keyof typeof limits] ?? 5,
)

const modalColors = useUiDialog('modal-colors')

const relatedColorProducts = computed(() => {
  return props.product?.relatedColorProducts
})

const productImageUrl = (url?: string, name?: string, size?: string, widthParam: number, heightParam: number) => {
  return getResizedProductImage(
    url,
    name,
    {
      width: widthParam,
      height: heightParam,
      imageSize: size,
      index: 1,
    },
  )
}
const link = (product: any) => {
  return `${product.url}`
}
</script>

<style>
@import url("~layers/app/components/Product/RelatedColorProducts.css");
</style>
